import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';
import { type CommonTemplateProps } from '../types.js';

type DiscardConfirmationModalProps = CommonTemplateProps & {
  readonly analyticsSection: string;
  readonly body?: string;
  readonly continueLabel?: string;
  readonly discardLabel?: string;
  readonly header: string;
  readonly onClose?: () => void;
  readonly onDiscard: () => void;
};

export const DiscardConfirmationModal = ({
  analyticsSection,
  body = 'Your work will be lost. This cannot be undone.',
  closeModal,
  continueLabel = 'Cancel',
  discardLabel = 'Discard',
  header,
  isOpen,
  modalName,
  onClose,
  onDiscard,
}: DiscardConfirmationModalProps) => {
  const { track } = useAnalytics();
  const handleClose = () => {
    track('modal', {
      action: 'tapped',
      cta: 'close',
      modal_name: modalName,
      section: analyticsSection,
    });
    onClose?.();
    closeModal();
  };

  const handleDiscard = () => {
    track('modal', {
      action: 'tapped',
      cta: 'discard',
      modal_name: modalName,
      section: analyticsSection,
    });
    onDiscard();
    closeModal();
  };

  return (
    <ModalTemplateWrapper
      ariaLabel="discard-confirmation-modal"
      ctaOptions={{
        primaryCTA: {
          handleOnClick: handleDiscard,
          isLoading: false,
          label: discardLabel,
          variant: 'V2Destructive',
        },
        secondaryCTA: {
          handleOnClick: handleClose,
          isLoading: false,
          label: continueLabel,
        },
      }}
      desktopModalSize="md"
      headerText={header}
      isOpen={isOpen}
      onClose={handleClose}
      subheaderText={body}
    />
  );
};
